import { z } from 'zod'

// Réponse de l'API à l'upload d'un fichier HTML de support
export const UploadedSupportFileSchema = z.object({
  storageKey: z.string().min(1),
  url: z.string().min(1),
  originalFileName: z.string(),
  fileSize: z.number(),
  contentHash: z.string()
})

export type UploadedSupportFile = z.infer<typeof UploadedSupportFileSchema>
